<template>
  <base-modal
      icon="announcement"
      title="Recover Changes"
      :hideCloseButton="true">
    <div class="message">
      <p>
        There are changes that have not been correctly saved.
        Would you like to recover them?
      </p>
      <p>
        Changed notes:
      </p>
      <ul>
        <li
            v-for="note in notes"
            :key="note.uuid">
          <strong v-if="note.summary">
            {{ note.summary }}
          </strong>
          <strong v-else>
            <i>Empty note</i>
          </strong>
          <i>
            (Updated {{ note.updated | relativeDate }})
          </i>
        </li>
      </ul>
    </div>
    <template #footer>
      <base-button
          text="Discard"
          @click="discard"/>
      <base-button
          text="Recover"
          @click="recover"/>
    </template>
  </base-modal>
</template>

<script>
import BaseButton from '@/components/core/BaseButton.vue';
import BaseModal from '@/components/core/modal/BaseModal.vue';

export default {
  name: 'RecoverChangesModal',
  components: {
    BaseModal,
    BaseButton,
  },
  props: {
    notes: Array,
  },
  methods: {
    discard() {
      this.$store.dispatch('notes/discardUnsavedNotes');
      this.$modal.dismiss();
    },
    recover() {
      this.$store.dispatch('notes/recoverUnsavedNotes');
      this.$modal.dismiss();
    },
  },
};
</script>

<style lang="scss" scoped>
.message {
  padding: 0.5rem 0.625rem;
  text-align: center;

  p {
    margin: 0 0 0.75rem;
  }

  ul {
    // padding-left: 2rem;
    list-style: none;
  }
}
</style>
